'use client'

// Wraps the Datadog *browser* SDK, so this module must stay out of server bundles. The
// directive turns any server-side import into a client reference that throws when called,
// which is the loud failure we want over silently evaluating the SDK in Node. Server
// Components and route handlers should log with console.error instead (see courtyard2's
// lib/error-logger.server.ts for the pattern).
import { addError } from '@knockaway/foundation-web-logger'
import { deepDelete } from '@phoenix-web/utils/general'
import { DD_ENABLED } from '@/constants'

const redactData = (data: Record<any, any>) => {
  return deepDelete(data, ['password', 'old_password', 'new_password'])
}

type trackErrorContext = {
  metaData?: {
    [key: string]: any
  }
  severity?: 'error' | 'warning'
}

export const trackError = (error: Error | unknown, context?: trackErrorContext): void => {
  if (!DD_ENABLED) return
  const ctx = redactData(context || {}) as trackErrorContext
  let newError = error
  if (!(error instanceof Error)) {
    if (typeof error === 'string') {
      newError = new Error(error as any)
    } else {
      newError = new Error((error as any)?.message || (error as any)?.name)
    }
    Object.assign(newError as any, error)
  }
  addError(newError, ctx)
}
